// 用来处理多国家多跳转的问题
// el: 传入的元素
// links: 站点地图文本

function parseSiteJumpMap(links) {
  const siteMap = {};
  String(links)
    .split("\n")
    .forEach((item) => {
      const [key, value] = item.split(": ");
      if (key && value) {
        siteMap[key.trim()] = value.trim();
      }
    });
  return siteMap;
}

function navigateSiteJump(links, el) {
  const countryElement = document.getElementsByClassName("countryWord")[0];
  if (!countryElement) {
    console.error("SiteJump: Country element not found");
    return;
  }

  const country = countryElement.innerText.trim();
  const siteMap = parseSiteJumpMap(links);
  let targetUrl = siteMap[country] || siteMap["default"] || "/";
  const hpm = window.zzGetElementHpm ? window.zzGetElementHpm(el) : "";

  if (hpm) {
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.set("hpm", hpm);
    targetUrl = url.toString();
  }

  window.location.href = targetUrl;
}

var bindSiteJump = bindSiteJump
  ? bindSiteJump
  : function bindSiteJump(el, links) {
      if (!el || !links) {
        throw new Error("SiteJump: el and links are required");
      }

      el.onclick = (event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        navigateSiteJump(links, el);
        return false;
      };
    };

// 移动端 drawer 会 clone innerHTML，onclick 不会复制，需事件委托
if (!window.__siteJumpDelegationBound) {
  window.__siteJumpDelegationBound = true;

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(
      ".menu-view-all-link-map-btn[data-link-map]",
    );
    if (!btn) return;

    event.preventDefault();

    const raw = btn.getAttribute("data-link-map");
    if (!raw) return;

    let links;
    try {
      links = JSON.parse(raw);
    } catch (error) {
      links = raw;
    }

    navigateSiteJump(links, btn);
  });
}
